import * as React from 'react';
import { Debounce } from 'react-throttle';

import AddressDescription from 'src/components/ShippingToChange/components/AddressDescription';
import OneTimeAddress from 'src/components/ShippingToChange/components/OneTimeAddress';
import SlideMenu from 'src/components/common/SlideMenu';
import AddressLoading from './components/AddressLoading';

import AddressModel from 'src/model/address.model';
import addressServiceInstance from 'src/services/address/AddressService';

import './ShippingToChange.scss';
import { breakpoints } from '../../utils/responsiveHelpers';
import i18n from 'src/translation/i18n';

interface IShippingToChangeState {
  addresses: AddressModel[];
  currentAddresses: AddressModel[];
  searchText: string;
  isMobile: boolean;
  showSlideMenu: boolean;
  loading: boolean;
}

interface IShippingToChangeProps {
  handleChangeAddress(address: AddressModel, oneTimeAddress: boolean): void;
  handleCloseMenu(): void;
  t?: any;
}

class ShippingToChange extends React.Component<
  IShippingToChangeProps,
  IShippingToChangeState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      addresses: [],
      currentAddresses: [],
      searchText: '',
      isMobile: this.isMobile(),
      showSlideMenu: false,
      loading: true
    };
  }

  private handleSearchInputChange = (e: any) => {
    this.setState({ searchText: e.target.value });
    this.handleSearchAddressChange();
  };

  private handleSearchAddressChange = () => {
    let results: AddressModel[] = [];
    if (this.state.searchText) {
      results = this.state.addresses.filter(address => {
        return (
          `${
            address.addressLine1
              ? `${address.addressLine1.toLocaleLowerCase()}, `
              : ''
          }${
            address.addressLine2
              ? `${address.addressLine2.toLocaleLowerCase()}, `
              : ''
          }${
            address.addressLine3
              ? `${address.addressLine3.toLocaleLowerCase()}, `
              : ''
          }${
            address.addressLine4
              ? `${address.addressLine4.toLocaleLowerCase()}, `
              : ''
          }${address.stateCode ? `${address.stateCode} ` : ''}${
            address.postalCode ? `${address.postalCode}` : ''
          }`
            .toLowerCase()
            .includes(this.state.searchText.toLowerCase()) ||
          address.name
            .toLowerCase()
            .includes(this.state.searchText.toLowerCase())
        );
      });
    } else {
      results = this.state.addresses;
    }
    this.setState({ currentAddresses: results, loading: false });
  };

  private handleShowSlideMenu = () => {
    this.setState({
      showSlideMenu: true
    });
    window.scrollTo(0, 0);
  };

  private handleCloseSlideMenu = () => {
    this.setState({
      showSlideMenu: false
    });
  };

  public componentDidMount() {
    addressServiceInstance.getAllAddresses().then(res => {
      this.setState({ addresses: res, currentAddresses: res, loading: false });
    });
  }

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  private isMobile = (): boolean => {
    return window.innerWidth <= breakpoints.medium;
  };

  private handleWindowSizeChange = () => {
    const isMobile = this.isMobile();
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  };

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-shipping-to-change">
        <div
          className="rp-shipping-to-change--addresses-container"
          style={{
            height: `${
              this.state.isMobile && this.state.showSlideMenu ? '693px' : 'auto'
            }`
          }}
        >
          <div className="rp-shipping-to-change--choose">
            <div>
              <label className="rp-shipping-to-change--choose-text">
                {i18n.t('product.chooseShippingAddress')}:
              </label>
              <div
                onClick={e => this.props.handleCloseMenu()}
                className="rp-shipping-to-change--go-back-title"
              >
                <span className="rpds-backspace go-back-arrow-icon" />
                {i18n.t('product.backToPreviousScreen')}
              </div>
            </div>
            <button
              className="rp-shipping-to-change--choose-one-time-address-button"
              onClick={this.handleShowSlideMenu}
            >
              {i18n.t('product.enterOneTimeAddress')}
              <span className="rpds rpds-chevron-right" />
            </button>
            <div className="rp-shipping-to-change--choose-input-container">
              <Debounce time="500" handler="onChange">
                <input
                  className="rp-shipping-to-change--choose-input"
                  placeholder={i18n.t(
                    'accountShippingAddress.searchAddressPlaceHolder'
                  )}
                  onChange={this.handleSearchInputChange}
                />
              </Debounce>
              <button
                className="primary-button rp-shipping-to-change--choose-button"
                onClick={this.handleSearchAddressChange}
              >
                <span className="rpds rpds-search" />
              </button>
            </div>
          </div>
          <div className="rp-shipping-to-change--addresses">
            {this.state.currentAddresses.length > 0 ? (
              this.state.currentAddresses.map(address => (
                <AddressDescription
                  key={address.number}
                  address={address}
                  handleClicDeliverAddress={this.props.handleChangeAddress}
                />
              ))
            ) : this.state.loading ? (
              <React.Fragment>
                <AddressLoading key={1} />
                <AddressLoading key={2} />
                <AddressLoading key={3} />
              </React.Fragment>
            ) : (
              <div className="rp-shipping-to-change--addresses--no-found">
                No addresses found.
              </div>
            )}
          </div>
        </div>
        {this.state.isMobile ? (
          <SlideMenu
            mounted={this.state.showSlideMenu}
            goBackTitle={i18n.t('common.back')}
            level={2 + 30}
            handleCloseMenu={this.handleCloseSlideMenu}
          >
            <OneTimeAddress
              handleClicDeliverAddress={this.props.handleChangeAddress}
            />
          </SlideMenu>
        ) : (
          <div className="rp-shipping-to-change--only-address">
            <OneTimeAddress
              handleClicDeliverAddress={this.props.handleChangeAddress}
            />
          </div>
        )}
      </div>
    );
  }
}

export default ShippingToChange;
